import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { CustomLabelProps, CustomLabelTypes } from './interfaces';

import useStyles from './style';

const CustomLabel: FC<PropsWithChildren<CustomLabelProps>> = ({
  className,
  size,
  type = CustomLabelTypes.default,
  children,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames('customLabel', size, classes.customLabel, className, type)}>
      {children}
    </div>
  );
};

export default CustomLabel;
